// Color constants moved to src/store/colorStore.ts (SSOT for JS-consumed colors).
// See `eventTypeColor`, `status`, `palette.mapLane` there.

export const DASHBOARD_CONSTANTS = {
  // Crossroad Dashboard constants
  CROSSROAD_DASHBOARD: {
    VEHICLE_CODES: {
      CAR: 301001,
      VAN: 301002,
      TRUCK: 301003,
      HEAVY_TRUCK: 301004,
      BUS: 301005,
      MOTORCYCLE: 301006,
      BICYCLE: 301007,
      UNKNOWN: 301000,
    },
    // React Query config
    REFETCH_INTERVAL_MS: 2000,
    STALE_TIME_MS: 500,
    CACHE_TIME_MS: 5 * 60 * 1000, // 5 minutes
  },

  // Common constants
  COMMON: {
    TIME_OPTIONS: [
      // TODO: i18n - hardcoded Korean string
      { id: 'radio-5min', label: '5분', value: '5' },
      { id: 'radio-15min', label: '15분', value: '15' },
      { id: 'radio-30min', label: '30분', value: '30' },
    ],
  },
} as const;

// PSC_PC0203001_BE_001 - "Traffic Volume by Vehicle" card buckets.
// The endpoint returns 8 raw object classes; the panel aggregates them into
// these 4 display buckets. Pedestrian (301008) is excluded from the panel.
// `color` keys reference colorStore NEWCOLOR; used by the peak-hours line chart.
export const VEHICLE_VOLUME_BUCKETS = [
  {
    title: 'light-vehicle',
    classes: ['301001', '301002', '301003', '301005'],
    color: 'accentOrange',
  }, // Car + Van + Truck + Bus #FC6605
  { title: 'heavy-vehicle', classes: ['301004'], color: 'danger' }, // Long Truck  #FF3B30
  { title: 'motorcycle', classes: ['301006'], color: 'accentGrape' }, // Motorcycle  #8D66FD
  { title: 'non-motor', classes: ['301007'], color: 'accentBlue' }, // Bicycle     #007AFF
] as const;

// PSC_PC0203001_BE_006 - "Event Category" cards. Maps each display title to its
// EVT_TP_* code so the panel keeps its established copy while reading real data.
export const EVENT_SUMMARY_CARDS = [
  { title: 'OVER SPEED', code: 'EVT_TP_SPD' },
  { title: 'JAYWALK', code: 'EVT_TP_JW' },
  { title: 'CONTRA FLOW', code: 'EVT_TP_WWD' },
  { title: 'SUDDEN STOP', code: 'EVT_TP_STP' },
] as const;

// for button on main dashboard
export const BUTTON_FILTER_SITE_LIST = [
  {
    id: 'filterSiteList1',
    label: '교차로',
    color: 'accentBlue',
    siteTypeValue: '교차로',
  },
  {
    id: 'filterSiteList2',
    label: '일반',
    color: 'accentYellow',
    siteTypeValue: '일반',
  },
] as const;

export const BUTTON_FILTER_EVENT_LIST = {
  EVT_TP_JW: {
    id: 'jaywalking',
    label: '무단횡단',
    color: 'accentBlue',
  },
  EVT_TP_SPD: {
    id: 'speeding',
    label: '속도 위반',
    color: 'accentYellow',
  },
  EVT_TP_STP: {
    id: 'suddentStop',
    label: '돌발정차',
    color: 'accentGrape',
  },
} as const;

export const BUTTON_FILTER_WEATHER_LIST = {
  pm10_1: {
    id: 'pm10bad',
    label: 'PM 10 나쁨',
    color: 'accentSoftGreen',
  },
  pm10_2: {
    id: 'pm10veryBad',
    label: 'PM 10 매우 나쁨',
    color: 'accentSoftRed',
  },
  pm25_1: {
    id: 'pm25bad',
    label: 'PM 2.5 나쁨',
    color: 'accentSoftYellow',
  },
  pm25_2: {
    id: 'pm25veryBad',
    label: 'PM 2.5 매우 나쁨',
    color: 'accentSoftGrape',
  },
} as const;

// button on ENV DASHBOARD
export const BUTTON_FILTER_WEATHER_LIST_ENV = [
  { id: 'pm10_1', label: '미세먼지 나쁨', color: 'accentBlue' },
  { id: 'pm10_2', label: '미세먼지 매우 나쁨', color: 'accentSoftYellow' },
  { id: 'pm25_1', label: '초미세먼지 나쁨', color: 'accentSoftGrape' },
  { id: 'pm25_2', label: '초미세먼지 매우 나쁨', color: 'accentCyan' },
] as const;

export type EnvEventType = (typeof BUTTON_FILTER_WEATHER_LIST_ENV)[number]['id'];
